import { WatchDisplayAttributes } from './watchDataAttributes';
import { CarDisplayAttributes } from './carDataAttributes';
import { ComicDisplayAttributes } from './comicDataAttributes';
import { OtherDisplayAttributes } from './otherDataAttributes';
import { ArtDisplayAttributes } from './artDataAttributes';
import { AntiqueDisplayAttributes } from './antiqueDataAttributes';
import { BookDisplayAttributes } from './bookDataAttributes';
import { CoinDisplayAttributes } from './coinDataAttributes';
import { StampDisplayAttributes } from './stampDataAttributes';
import { CameraDisplayAttributes } from './cameraDataAttributes';
import { FirearmDisplayAttributes } from './firearmDataAttributes';
import { HandbagDisplayAttributes } from './handbagDataAttributes';
import { JewelryDisplayAttributes } from './jewelryDataAttributes';
import { ToyDisplayAttributes } from './toyDataAttributes';
import { HistoricalMemDisplayAttributes } from './historicalMemorabiliaDataAttributes';
import { MovieMemDisplayAttributes } from './movieMemorabiliaDataAttributes';
import { MusicalInstrumentDisplayAttributes } from './musicalInstrumentDataAttributes';
import { MusicMemDisplayAttributes } from './musicMemorabiliaDataAttributes';
import { SportsMemDisplayAttributes } from './sportsMemorabiliaDataAttributes';
import { WineDisplayAttributes } from './wineDataAttributes';
import { SportsCardDisplayAttributes } from './sportsCardDataAttributes';
import { VinylRecordDisplayAttributes } from './vinylRecordDataAttributes';

export default {

  details: {
    WATCH: WatchDisplayAttributes,
    CAR: CarDisplayAttributes,
    COMIC: ComicDisplayAttributes,
    OTHER: OtherDisplayAttributes,
    ART: ArtDisplayAttributes,
    ANTIQUE: AntiqueDisplayAttributes,
    BOOK: BookDisplayAttributes,
    COIN: CoinDisplayAttributes,
    STAMP: StampDisplayAttributes,
    CAMERA: CameraDisplayAttributes,
    FIREARM: FirearmDisplayAttributes,
    HANDBAG: HandbagDisplayAttributes,
    JEWELRY: JewelryDisplayAttributes,
    TOY: ToyDisplayAttributes,
    MUSICAL_MEM: MusicMemDisplayAttributes,
    SPORTS_MEM: SportsMemDisplayAttributes,
    HISTORIC_MEM: HistoricalMemDisplayAttributes,
    MOVIE_MEM: MovieMemDisplayAttributes,
    MUSICAL_INST: MusicalInstrumentDisplayAttributes,
    WINE: WineDisplayAttributes,
    SPORTS_CARD: SportsCardDisplayAttributes,
    VINYL_RECORD: VinylRecordDisplayAttributes,
  },
};



// WEBPACK FOOTER //
// ./src/config/displayItems.js